import { combineReducers } from 'redux';
import { DoggosActionTypes, initialDoggosState } from './types';
import createAsyncReducer from '~lib/shared/redux/reducers/async-reducer';
export const listOfficeDoggos = createAsyncReducer(DoggosActionTypes.LIST_OFFICE_DOGGOS, initialDoggosState.listOfficeDoggos);
export default combineReducers({
    listOfficeDoggos,
});
